export const handleInvalidToken = (store) => (next) => (action) => {
  if (action.type.substr(action.type.length - 6) === "FAILED") {
    if ((((action.payload || {}).error || {}).response || {}).status === 401) {
      store.dispatch({ type: "CLEAR_API_TOKEN" });
    }
  }

  return next(action);
};
